import React from 'react';

export const VideoSettings = ({
  brightness,
  setBrightness,
  defaultBrightnessValue,
  contrast,
  setContrast,
  defaultContrastValue,
}: {
  brightness: number;
  setBrightness: (brightness: number) => void;
  defaultBrightnessValue: number;
  contrast: number;
  setContrast: (contrast: number) => void;
  defaultContrastValue: number;
}) => {
  return (
    <div className="VideoSettings">
      <div className="VideoSettings_Setting">
        <div>Brightness</div>
        <input
          type="range"
          min="0"
          max="2"
          step="0.05"
          value={brightness}
          onChange={e => setBrightness(Number(e.target.value))}
        />
        <button
          type="button"
          className="Button"
          onClick={() => setBrightness(defaultBrightnessValue)}
        >
          Reset
        </button>
      </div>
      <div className="VideoSettings_Setting">
        <div>Contrast</div>
        <input
          type="range"
          min="0"
          max="2"
          step="0.05"
          value={contrast}
          onChange={e => setContrast(Number(e.target.value))}
        />
        <button
          type="button"
          className="Button"
          onClick={() => setContrast(defaultContrastValue)}
        >
          Reset
        </button>
      </div>
    </div>
  );
};
